<template>
	<div class="bbs_tit_g">
		<div class="tit_info">
			<strong class="tit_item">
				<span class="search_query">'{{ query }}'</span>
				<span class="result_txt">검색결과</span>
			</strong>
		</div>
		<div class="extend_info" v-if="showsDaumSearchLink">
			<a target="_blank" rel="noopener" :href="daumSearchUrl" class="search_daum">검색결과 더보기</a>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		query: {
			type: String,
			required: true
		},
		isNicknameSearch: {
			type: String,
			required: true
		}
	},
	computed: {
		// 작성자 검색이 아닐때만 다음 검색 링크를 보여줌.
		showsDaumSearchLink() {
			return !this.isNicknameSearch;
		},
		daumSearchUrl() {
			return `https://search.daum.net/search?w=cafe&enc=utf8&ASearchType=1&m=board&q=${this.query}`;
		}
	}
}
</script>
